import { DateTime } from 'luxon';
import escapeHtml from './escapeHtml.js';

export default class Format {

    options = {
        locale: (typeof process !== 'undefined' && process.env && process.env.INTL_LOCALE) ? process.env.INTL_LOCALE: 'sv-SE',
        currency: (typeof process !== 'undefined' && process.env && process.env.CURRENCY) ? process.env.CURRENCY: 'SEK'
    }

    constructor(style, decimals) {
        this.formatter = new Intl.NumberFormat(this.options.locale, { 
            style: style, 
            currency: this.options.currency, 
            maximumFractionDigits: decimals,
            minimumFractionDigits: decimals
        });
    }

    static currency(value, decimals = 0) {
        return (new this('currency', decimals)).formatter.format(value);
    }

    static number(value, decimals = 0) {
        return (new this('decimal', decimals)).formatter.format(value);
    }

    static percentage(value, decimals = 2) {
        return `${(new this('decimal', decimals)).formatter.format(value)} %`;
    }

    static excerpt(string, length = 100) {
        return string.substr(0, 100) + '...';
    }

    static date(dateIso, luxonFormatKey = 'DATE_SHORT') {
        const dt = DateTime.fromISO(dateIso)
        return dt.toLocaleString(DateTime[luxonFormatKey]);
    }

    static comment(text) {
        if (! text) {
            return '';
        }
        return text
            .split('\n')
            .filter((line) => line.trim() !== '')
            .map((line) => `<p>${escapeHtml(line)}</p>`)
            .join('');
    }
}